// Init Splide.js
// es6
//
// uses:
// - https://splidejs.com/

function initSplide() {
    if (
        typeof window.ProjectEnv === 'undefined' ||
        window.ProjectEnv === null ||
        !window.ProjectEnv.splide ||
        !document.querySelector('[data-splide]')
    ) {
        return;
    }

    import(window.ProjectEnv.splide.module).then(({ default: Splide }) => {
        document.querySelectorAll('[data-splide]').forEach((el) => {
            const options = { keyboard: 'focused', ...el.dataset.splide ? JSON.parse(el.dataset.splide) : {} };
            const current = el.querySelector('[data-splide-current]');
            const total = el.querySelector('[data-splide-total]');
            const splide = new Splide(el, options);


            if (current && total) {
                splide.on('mounted move', (newIndex,prevIndex,destIndex) => {
                    const index = newIndex ?? splide.index;
                    current.textContent = index + 1;
                    total.textContent = splide.length;
                });
            }

            splide.on('overflow', (isOverflow) => {
                splide.go(0);
                splide.options = {
                    arrows: isOverflow && (options.arrows ?? true),
                    pagination: isOverflow && (options.pagination ?? true),
                    drag: isOverflow && (options.drag ?? true),
                    clones: isOverflow ? undefined : 0,
                };
            });


            splide.mount();
        });
    });
}

initSplide();
